import { getFetch } from '../fetch';

const URL = '/turing-api/subscriptions';

type Subscription =
    | 'yau_ege'
    | 'yateachers'
    | 'kryau'
    | 'yau_newprod'
    | 'yautpromo';

type Subscriptions = Record<Subscription, boolean>;

export function getNewSubscriptions(): Promise<Subscriptions> {
    return getFetch(URL);
}
